import * as React            from 'react';
import Tippy, { TippyProps } from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';
import style                 from './Tooltip.scss';

export default function Tooltip(props: TippyProps) {
  return (
    <Tippy className={style.container} animation="shift-away" duration={100} appendTo={document.body} {...props} />
  );
}
